import { render } from "./OfferServices.vue?vue&type=template&id=959e1dd8"
import script from "./OfferServices.vue?vue&type=script&lang=js"
export * from "./OfferServices.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__